import PropTypes from 'prop-types';
import { equals } from 'ramda';
import booleanOptions from '@@viewCommonComponents/forms/options';
import { useFormContext } from 'react-hook-form';
import BankInformations from './BankInformations';
import { ControlledRadioButton } from '@@viewCommonComponents/controlled';
import { isRequiredBoolean } from '@@viewHelpers/validations';
import { DashedTitle } from '@fasstech/middle-design-system';
import React from 'react';

const RefundInformations = ({ getMiddleText, getMiddleBoolean }) => {
  const form = useFormContext();
  const {
    watch,
    getValues
  } = form;

  const paymentTypeIsPrelevement = equals('PRELEVEMENT', getValues('bankAccounts.0.type'));
  const displayRefundInformations = watch('radioDisplayRefundInformations');

  return (
    <>
      {paymentTypeIsPrelevement && (
        <ControlledRadioButton
          label={getMiddleText('PAIEMENTETREMBOURSEMENT_REMBOURSEMENT_QUESTION_LABEL')}
          name="radioDisplayRefundInformations"
          booleanValue
          rules={isRequiredBoolean(
            getMiddleBoolean('PAIEMENTETREMBOURSEMENT_REMBOURSEMENT_EST_OBLIGATOIRE')
          )}
          options={booleanOptions}
          form={form}
          data-testid="PAIEMENTETREMBOURSEMENT_REMBOURSEMENT_QUESTION"
        />
      )}

      {(displayRefundInformations || !paymentTypeIsPrelevement) && (
        <>
          <DashedTitle>{getMiddleText('PAIEMENTETREMBOURSEMENT_REMBOURSEMENT_TITLE')}</DashedTitle>
          <BankInformations
            fieldsPrefix="customer.bankAccounts.0"
            getMiddleText={getMiddleText}
            getMiddleBoolean={getMiddleBoolean}
            isCustomer={true}
          />
        </>
      )}
    </>
  );
};

RefundInformations.propTypes = {
  displayInformations: PropTypes.number,
  setDisplayInformations: PropTypes.func,
  getMiddleBoolean: PropTypes.func,
  getMiddleText: PropTypes.func
};

export default RefundInformations;
